import { PaymentMethod } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { buyerPhoneSchema } from '../_shared/phone.js';
export const SessionPaymentType = {
    DEPOSIT: 'DEPOSIT',
    FULL: 'FULL',
};
export const billingAddressSchema = z.object({
    city: z.string().min(1),
    countryCode: z.string().min(1),
    // SSP rejects purely-numeric street names; require at least one letter so a
    // bare house number can never reach the provider.
    street: z.string().min(1).regex(/[A-Za-zÀ-ÿ]/, 'street must contain at least one letter'),
    zipCode: z.string().min(1),
});
export const floaPayTypeSchema = z.enum(['3XG', '4XG']);
/**
 * Paiement en plusieurs fois (INSTALLMENTS) : adresse de facturation requise.
 * Prestataire selon le flag runtime (backoffice) : SSP (choix 3x/4x sur la page
 * hébergée SSP) ou FLOA (choix 3x/4x côté Massilia via `floaPayType`).
 * `floaPayType` reste optionnel au niveau contrat car sa requiredness dépend du
 * flag ; le serveur la valide au checkout.
 */
export const initiateSessionCheckoutSchema = z
    .object({
    buyerEmail: z.string().optional(),
    billingAddress: billingAddressSchema.optional(),
    buyerPhone: buyerPhoneSchema.optional(),
    depositAmount: z.number().min(0).optional(),
    floaPayType: floaPayTypeSchema.optional(),
    paymentMethod: z.nativeEnum(PaymentMethod),
    paymentType: z.nativeEnum(SessionPaymentType),
    subscribeToNotifications: z.boolean().optional(),
})
    .superRefine((data, ctx) => {
    if (data.paymentMethod === PaymentMethod.INSTALLMENTS && !data.billingAddress) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "L'adresse de facturation est requise pour le paiement en plusieurs fois.",
            path: ['billingAddress'],
        });
    }
});
